import { render, staticRenderFns } from "./growthList.vue?vue&type=template&id=1f366294&"
import script from "./growthList.vue?vue&type=script&lang=js&"
export * from "./growthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports